import { render, staticRenderFns } from "./standard-plan.vue?vue&type=template&id=04db181a&scoped=true"
import script from "./standard-plan.vue?vue&type=script&lang=js"
export * from "./standard-plan.vue?vue&type=script&lang=js"
import style0 from "./standard-plan.vue?vue&type=style&index=0&id=04db181a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04db181a",
  null
  
)

export default component.exports